  import React from 'react';
  import { motion } from 'framer-motion';

  import '../assets/web/assets/mobirise-icons2/mobirise2.css';
  import '../assets/bootstrap/css/bootstrap.min.css';
  import '../assets/bootstrap/css/bootstrap-grid.min.css';
  import '../assets/bootstrap/css/bootstrap-reboot.min.css';
  import '../assets/parallax/jarallax.css';
  import '../assets/web/assets/gdpr-plugin/gdpr-styles.css';
  import '../assets/dropdown/css/style.css';
  import '../assets/socicon/css/styles.css';
  import '../assets/theme/css/style.css';
  import '../assets/mobirise/css/mbr-additional.css';

  import Navbar from './components/Navbar';
  import Footer from './components/Footer';
  import TrabalheForm from './components/forms/TrabalheForm';

  import civil from './assets/images/1.jpg';
  import iluminacao from './assets/images/2.png';
  import construcao from './assets/images/8.jpg';

  const fadeUp = {
    hidden: { opacity: 0, y: 28 },
    show: { opacity: 1, y: 0 },
  };

  const stagger = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.12,
      },
    },
  };

  const sectionReveal = {
    initial: 'hidden',
    whileInView: 'show',
    viewport: { once: true, amount: 0.18 },
    variants: fadeUp,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
  };

  function SectionTag({ children, light = false }) {
    return (
      <span
        style={{
          display: 'inline-block',
          marginBottom: '14px',
          fontSize: '0.82rem',
          fontWeight: 700,
          letterSpacing: '1.4px',
          textTransform: 'uppercase',
          color: light ? '#d6a04a' : '#b7832f',
        }}
      >
        {children}
      </span>
    );
  }

  function SectionTitle({ children, center = false, light = false, maxWidth = '760px' }) {
    return (
      <h2
        style={{
          fontSize: 'clamp(2rem, 3vw, 3.2rem)',
          lineHeight: 1.12,
          fontWeight: 800,
          letterSpacing: '-0.8px',
          color: light ? '#ffffff' : '#0d2e63',
          marginBottom: '18px',
          maxWidth,
          marginLeft: center ? 'auto' : 0,
          marginRight: center ? 'auto' : 0,
        }}
      >
        {children}
      </h2>
    );
  }

  function SectionText({ children, center = false, light = false, maxWidth = '760px' }) {
    return (
      <p
        style={{
          fontSize: '1.04rem',
          lineHeight: 1.9,
          color: light ? 'rgba(255,255,255,0.78)' : '#5f7088',
          maxWidth,
          margin: center ? '0 auto' : 0,
        }}
      >
        {children}
      </p>
    );
  }

  function TrabalheConosco() {
    const highlights = [
      {
        title: 'Valorização de pessoas',
        text: 'Acreditamos no desenvolvimento de talentos e na construção de relações profissionais baseadas em respeito, responsabilidade e confiança.',
      },
      {
        title: 'Ambiente de crescimento',
        text: 'Buscamos profissionais que queiram evoluir junto com a empresa e contribuir com projetos relevantes em diferentes segmentos.',
      },
      {
        title: 'Inclusão e diversidade',
        text: 'Promovemos oportunidades com olhar humano e compromisso com um ambiente mais diverso, acessível e acolhedor.',
      },
    ];

    const reasons = [
      {
        title: 'Projetos de impacto',
        text: 'Atuação em energia, infraestrutura, manutenção, iluminação, saneamento e operações especializadas.',
      },
      {
        title: 'Equipe multidisciplinar',
        text: 'Convivência com profissionais de diferentes áreas técnicas e operacionais, ampliando troca de conhecimento e aprendizado.',
      },
      {
        title: 'Compromisso com qualidade',
        text: 'Valorização de boas práticas, segurança, organização e desempenho em cada etapa do trabalho.',
      },
      {
        title: 'Visão de futuro',
        text: 'Uma empresa que segue evoluindo com tecnologia, experiência de campo e desenvolvimento contínuo.',
      },
    ];

    return (
      <div
        style={{
          background: 'linear-gradient(180deg, #f3f6fb 0%, #ffffff 30%, #f7f9fc 100%)',
          color: '#11233e',
          fontFamily: 'Arial, sans-serif',
          overflow: 'hidden',
        }}
      >
        <Navbar />

        <section
          style={{
            position: 'relative',
            minHeight: '72vh',
            display: 'flex',
            alignItems: 'center',
            backgroundImage: `linear-gradient(95deg, rgba(8,20,41,0.95) 0%, rgba(10,33,70,0.9) 42%, rgba(13,52,110,0.68) 100%), url(${civil})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background:
                'radial-gradient(circle at 15% 20%, rgba(255,255,255,0.08), transparent 22%), radial-gradient(circle at 85% 12%, rgba(214,160,74,0.18), transparent 16%)',
            }}
          />

          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row align-items-center g-5">
              <div className="col-lg-7">
                <motion.div {...sectionReveal} style={{ maxWidth: '760px', padding: '50px 0' }}>
                  <div
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '10px',
                      padding: '10px 16px',
                      borderRadius: '999px',
                      background: 'rgba(255,255,255,0.08)',
                      border: '1px solid rgba(255,255,255,0.12)',
                      color: 'rgba(255,255,255,0.84)',
                      fontSize: '13px',
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                      marginBottom: '24px',
                    }}
                  >
                    Carreiras na RealEnergy
                  </div>

                  <h1
                    style={{
                      fontSize: 'clamp(2.5rem, 5vw, 4.7rem)',
                      lineHeight: 1.03,
                      fontWeight: 800,
                      letterSpacing: '-1.2px',
                      color: '#ffffff',
                      marginBottom: '22px',
                    }}
                  >
                    Faça parte de uma empresa que valoriza pessoas, experiência e desenvolvimento.
                  </h1>

                  <p
                    style={{
                      fontSize: '1.08rem',
                      lineHeight: 1.9,
                      color: 'rgba(255,255,255,0.82)',
                      maxWidth: '650px',
                    }}
                  >
                    Na RealEnergy, buscamos profissionais comprometidos, preparados para contribuir com projetos
                    relevantes e dispostos a crescer em um ambiente que une responsabilidade, qualidade e visão de futuro.
                  </p>
                </motion.div>
              </div>

              <div className="col-lg-5">
                <motion.div
                  initial={{ opacity: 0, y: 34 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.2 }}
                  transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.08 }}
                  style={{ position: 'relative', maxWidth: '500px', marginLeft: 'auto' }}
                >
                  <motion.div
                    animate={{ y: [0, -8, 0] }}
                    transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
                    style={{
                      position: 'relative',
                      background: 'rgba(255,255,255,0.08)',
                      border: '1px solid rgba(255,255,255,0.12)',
                      borderRadius: '30px',
                      padding: '18px',
                      backdropFilter: 'blur(16px)',
                      boxShadow: '0 30px 80px rgba(0,0,0,0.24)',
                    }}
                  >
                    <img
                      src={construcao}
                      alt="Trabalhe na RealEnergy"
                      style={{
                        width: '100%',
                        height: '420px',
                        objectFit: 'cover',
                        borderRadius: '24px',
                        display: 'block',
                      }}
                    />

                    <motion.div
                      initial={{ opacity: 0, x: -20 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.6, delay: 0.25 }}
                      whileHover={{ y: -4 }}
                      style={{
                        position: 'absolute',
                        left: '-20px',
                        bottom: '34px',
                        width: '250px',
                        background: 'rgba(255,255,255,0.97)',
                        borderRadius: '22px',
                        padding: '18px',
                        boxShadow: '0 20px 55px rgba(15, 23, 42, 0.18)',
                      }}
                    >
                      <div
                        style={{
                          fontSize: '0.78rem',
                          color: '#b7832f',
                          textTransform: 'uppercase',
                          letterSpacing: '1px',
                          marginBottom: '8px',
                          fontWeight: 700,
                        }}
                      >
                        Oportunidades
                      </div>
                      <div
                        style={{
                          fontWeight: 800,
                          fontSize: '1.12rem',
                          marginBottom: '6px',
                          color: '#0d2e63',
                          lineHeight: 1.3,
                        }}
                      >
                        Talentos que crescem junto com a empresa.
                      </div>
                      <div style={{ color: '#607089', fontSize: '0.95rem', lineHeight: 1.6 }}>
                        Um espaço para profissionais que desejam construir uma trajetória com propósito e evolução.
                      </div>
                    </motion.div>
                  </motion.div>
                </motion.div>
              </div>
            </div>
          </div>
        </section>

        <section style={{ marginTop: '-48px', position: 'relative', zIndex: 3 }}>
          <div className="container">
            <motion.div
              {...sectionReveal}
              style={{
                background: 'rgba(255,255,255,0.95)',
                borderRadius: '28px',
                boxShadow: '0 24px 70px rgba(15, 23, 42, 0.08)',
                border: '1px solid rgba(15, 23, 42, 0.05)',
                padding: '30px',
              }}
            >
              <motion.div
                className="row g-4"
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.15 }}
              >
                {highlights.map((item, index) => (
                  <div className="col-lg-4" key={index}>
                    <motion.div
                      variants={fadeUp}
                      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                      whileHover={{ y: -8, boxShadow: '0 24px 48px rgba(13, 46, 99, 0.08)' }}
                      style={{
                        background: '#ffffff',
                        borderRadius: '22px',
                        padding: '28px 24px',
                        height: '100%',
                        border: '1px solid rgba(13, 46, 99, 0.06)',
                      }}
                    >
                      <div
                        style={{
                          width: '56px',
                          height: '56px',
                          borderRadius: '16px',
                          background: 'linear-gradient(135deg, #edf3ff, #f7efe1)',
                          marginBottom: '18px',
                        }}
                      />

                      <h3
                        style={{
                          fontSize: '1.22rem',
                          fontWeight: 800,
                          marginBottom: '12px',
                          color: '#0d2e63',
                        }}
                      >
                        {item.title}
                      </h3>

                      <p style={{ color: '#607089', lineHeight: 1.8, marginBottom: 0 }}>{item.text}</p>
                    </motion.div>
                  </div>
                ))}
              </motion.div>
            </motion.div>
          </div>
        </section>

        <section style={{ padding: '110px 0 70px' }}>
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-6">
                <motion.div {...sectionReveal}>
                  <SectionTag>Por que trabalhar conosco</SectionTag>
                  <SectionTitle>
                    Uma empresa em constante evolução, com espaço para talentos que fazem a diferença.
                  </SectionTitle>
                  <SectionText maxWidth="620px">
                    A RealEnergy acredita que o crescimento sustentável de uma empresa passa pela valorização das pessoas,
                    pela troca de conhecimento e pelo fortalecimento de uma cultura de responsabilidade, respeito e desenvolvimento.
                  </SectionText>
                  <div style={{ height: '10px' }} />
                  <SectionText maxWidth="620px">
                    Buscamos profissionais que compartilhem desse compromisso e que desejem atuar em projetos relevantes,
                    contribuindo com dedicação, qualidade e visão de futuro.
                  </SectionText>
                </motion.div>
              </div>

              <div className="col-lg-6">
                <motion.div {...sectionReveal} style={{ position: 'relative', minHeight: '560px' }}>
                  <motion.img
                    whileHover={{ y: -6, scale: 1.01 }}
                    transition={{ duration: 0.35 }}
                    src={civil}
                    alt="Equipe e projetos"
                    style={{
                      width: '78%',
                      height: '420px',
                      objectFit: 'cover',
                      borderRadius: '30px',
                      boxShadow: '0 22px 60px rgba(15, 23, 42, 0.14)',
                      display: 'block',
                    }}
                  />
                  <motion.img
                    whileHover={{ y: -6, scale: 1.01 }}
                    transition={{ duration: 0.35 }}
                    src={iluminacao}
                    alt="Desenvolvimento profissional"
                    style={{
                      width: '58%',
                      height: '260px',
                      objectFit: 'cover',
                      borderRadius: '26px',
                      boxShadow: '0 22px 60px rgba(15, 23, 42, 0.14)',
                      position: 'absolute',
                      right: 0,
                      bottom: 0,
                      border: '8px solid #f7f9fc',
                    }}
                  />
                </motion.div>
              </div>
            </div>
          </div>
        </section>

        <section style={{ padding: '20px 0 90px' }}>
          <div className="container">
            <motion.div {...sectionReveal} className="text-center" style={{ maxWidth: '860px', margin: '0 auto 50px' }}>
              <SectionTag>Oportunidades e cultura</SectionTag>
              <SectionTitle center maxWidth="860px">
                Um ambiente voltado à responsabilidade, ao aprendizado e à construção de trajetórias consistentes.
              </SectionTitle>
              <SectionText center maxWidth="820px">
                Trabalhar na RealEnergy é fazer parte de uma estrutura que valoriza desempenho, segurança, organização e colaboração
                em diferentes áreas e níveis de atuação.
              </SectionText>
            </motion.div>

            <motion.div
              className="row g-4"
              variants={stagger}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.1 }}
            >
              {reasons.map((item, index) => (
                <div className="col-md-6 col-xl-3" key={index}>
                  <motion.div
                    variants={fadeUp}
                    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                    whileHover={{ y: -10 }}
                    style={{
                      background: '#ffffff',
                      borderRadius: '24px',
                      padding: '26px 22px',
                      height: '100%',
                      boxShadow: '0 18px 48px rgba(15, 23, 42, 0.07)',
                      border: '1px solid rgba(13, 46, 99, 0.05)',
                    }}
                  >
                    <div
                      style={{
                        width: '54px',
                        height: '54px',
                        borderRadius: '16px',
                        background: 'linear-gradient(135deg, #edf3ff, #f7efe1)',
                        marginBottom: '18px',
                      }}
                    />
                    <h3
                      style={{
                        fontSize: '1.08rem',
                        fontWeight: 800,
                        color: '#0d2e63',
                        marginBottom: '12px',
                        lineHeight: 1.35,
                      }}
                    >
                      {item.title}
                    </h3>
                    <p style={{ color: '#607089', lineHeight: 1.8, marginBottom: 0 }}>{item.text}</p>
                  </motion.div>
                </div>
              ))}
            </motion.div>
          </div>
        </section>

        <section style={{ padding: '0 0 110px' }}>
          <div className="container">
            <motion.div
              {...sectionReveal}
              style={{
                background: '#ffffff',
                borderRadius: '30px',
                padding: '36px',
                boxShadow: '0 24px 60px rgba(15, 23, 42, 0.08)',
                border: '1px solid rgba(15, 23, 42, 0.05)',
              }}
            >
              <div className="row align-items-center g-4 mb-4">
                <div className="col-lg-7">
                  <SectionTag>Cadastre seu currículo</SectionTag>
                  <SectionTitle maxWidth="680px">
                    Envie suas informações e venha construir novas oportunidades com a RealEnergy.
                  </SectionTitle>
                  <SectionText maxWidth="720px">
                    Preencha o formulário abaixo para participar do nosso banco de talentos ou de processos seletivos futuros.
                    Todas as informações serão tratadas com atenção e alinhadas à nossa política de respeito e profissionalismo.
                  </SectionText>
                </div>

                <div className="col-lg-5">
                  <motion.div
                    whileHover={{ y: -6 }}
                    style={{
                      background: 'linear-gradient(135deg, #ffffff, #f8fbff)',
                      borderRadius: '24px',
                      padding: '24px',
                      border: '1px solid rgba(13, 46, 99, 0.06)',
                      boxShadow: '0 16px 40px rgba(15, 23, 42, 0.06)',
                    }}
                  >
                    <div
                      style={{
                        fontSize: '1.08rem',
                        fontWeight: 800,
                        color: '#0d2e63',
                        marginBottom: '10px',
                      }}
                    >
                      Importante
                    </div>
                    <p style={{ color: '#607089', lineHeight: 1.8, marginBottom: 0 }}>
                      Incentivamos a participação de diferentes perfis profissionais e reforçamos nosso compromisso com inclusão, respeito e igualdade de oportunidades.
                    </p>
                  </motion.div>
                </div>
              </div>

              <div
                style={{
                  background: '#f7f9fc',
                  borderRadius: '24px',
                  padding: '22px',
                  border: '1px solid rgba(13, 46, 99, 0.06)',
                }}
              >
                <TrabalheForm />
              </div>
            </motion.div>
          </div>
        </section>

        <Footer />
      </div>
    );
  }

  export default TrabalheConosco;